import React, { useContext, ReactNode } from "react"
import { useMediaQuery } from "react-responsive"
import { WindowSize } from "Const"

const MediaQueryContext = React.createContext({
  isSmartPhone: false,
  isTablet: false,
  isMobile: false,
  isPc: false
})
/**
 * JS側のメディアクエリ用関数
 * @param {ReactNode} children - メディアクエリを利用する子要素
 */
export const MediaQueryProvider = ({ children }: { children: ReactNode }) => {
  const isSmartPhone = useMediaQuery({ maxWidth: WindowSize.MobileMaxWidth })
  const isTablet = useMediaQuery({
    minWidth: WindowSize.MobileMaxWidth + 1,
    maxWidth: WindowSize.TabletMaxWidth
  })
  const isMobile = isSmartPhone || isTablet
  const isPc = !isMobile

  return (
    <MediaQueryContext.Provider value={{ isSmartPhone, isTablet, isMobile, isPc }}>
      {children}
    </MediaQueryContext.Provider>
  )
}

export const useDeviceType = () => useContext(MediaQueryContext)
